import React from 'react';
import { TableWrapper } from './TableWrapper';
interface ProtocolsTabProps {
  searchTerm: string;
}
export function ProtocolsTab({
  searchTerm
}: ProtocolsTabProps) {
  const protocols = [{
    name: 'Million Dollar Combo for Back Pain',
    indications: 'Lower back pain, sciatica, lumbar disc problems, chronic back pain',
    leftPoints: 'GB 39, BL 57, BL 60, KI 6, GB 41, TH 5, SI 3, BL 62',
    rightPoints: 'GB 39, BL 57, BL 60, KI 6, GB 41',
    actions: 'Strengthens kidneys, moves blood stasis, relaxes lower back muscles. Alternate sides between treatments.'
  }, {
    name: 'Million Dollar Combo for Neck Pain',
    indications: 'Neck pain, cervical problems, whiplash, neck stiffness',
    leftPoints: 'HEALTHY SIDE ONLY: BL 60, KI 6, GB 41, TH 5, SI 3, BL 62, GB 39, BL 57',
    rightPoints: 'NO POINTS - Use healthy side only',
    actions: 'Always needle opposite side from pain. Opens yang qiao and yin qiao mai. Critical: Never needle painful side.'
  }, {
    name: 'Million Dollar Combo for Shoulder Pain',
    indications: 'Shoulder pain, frozen shoulder, rotator cuff injury, shoulder impingement',
    leftPoints: 'BL 60, KI 6, GB 41, TH 5, SI 3, BL 62',
    rightPoints: 'BL 60, KI 6, GB 41, TH 5, SI 3, BL 62',
    actions: 'Opens all eight extraordinary vessels. Moves qi and blood in shoulder region. Very effective for frozen shoulder.'
  }, {
    name: 'Million Dollar Combo for Fibromyalgia',
    indications: 'Fibromyalgia, widespread body pain, chronic fatigue, tender points',
    leftPoints: 'BL 60, KI 6, GB 41, TH 5, SI 3, BL 62',
    rightPoints: 'BL 60, KI 6, GB 41, TH 5, SI 3, BL 62',
    actions: 'Regulates all extraordinary vessels. Treats systemic yang qi deficiency. Use bilateral approach for systemic conditions.'
  }, {
    name: 'Million Dollar Combo for Headache',
    indications: 'All types of headaches, migraines, tension headaches, cluster headaches',
    leftPoints: 'BL 60, KI 6, GB 41, TH 5, SI 3, BL 62',
    rightPoints: 'BL 60, KI 6, GB 41, TH 5, SI 3, BL 62',
    actions: 'Opens all extraordinary vessels. Very effective for all headache types. Can be used bilaterally for chronic patterns.'
  }, {
    name: '12 Magic Points for Heart',
    indications: 'Heart disease, chest pain, palpitations, arrhythmia, angina, hypertension',
    leftPoints: 'HT 7, PC 6, PC 7, PC 8, LR 3, KI 3',
    rightPoints: 'HT 7, PC 6, PC 7, PC 8, LR 3, KI 3',
    actions: 'Calms shen, regulates heart qi, nourishes heart yin. Use for all cardiovascular disorders.'
  }, {
    name: '8 Magic Points for Digestion',
    indications: 'All digestive disorders, IBS, gastritis, bloating, poor appetite',
    leftPoints: 'ST 36, SP 3, SP 6, LR 3',
    rightPoints: 'ST 36, SP 3, SP 6, LR 3',
    actions: 'Strengthens spleen qi, harmonizes liver and spleen. Master points for all digestive issues.'
  }, {
    name: '4 Magic Points for Constipation',
    indications: 'Constipation, chronic constipation, elderly constipation, post-operative constipation',
    leftPoints: 'ST 36, SP 6',
    rightPoints: 'ST 36, SP 6',
    actions: 'Strengthens spleen qi, moistens intestines. Very effective for chronic constipation.'
  }, {
    name: '4 Magic Points for Diarrhea',
    indications: 'Diarrhea, loose stools, IBS with diarrhea, chronic diarrhea',
    leftPoints: 'ST 36, SP 6',
    rightPoints: 'ST 36, SP 6',
    actions: 'Strengthens spleen qi, stops diarrhea. Same points as constipation but different needling technique.'
  }, {
    name: '8 Magic Points for Shen',
    indications: 'Anxiety, depression, insomnia, panic attacks, PTSD, emotional instability',
    leftPoints: 'HT 7, YT 7, KI 3, SP 6',
    rightPoints: 'HT 7, YT 7, KI 3, SP 6',
    actions: 'Calms shen, nourishes heart and kidney yin. Master protocol for all emotional disorders.'
  }, {
    name: '8 Magic Points for OB/GYN',
    indications: 'All gynecological problems, menstrual disorders, fertility, menopause',
    leftPoints: 'SP 6, LR 3, REN 3, KI 3',
    rightPoints: 'SP 6, LR 3, REN 3, KI 3',
    actions: "Regulates chong and ren mai. Master protocol for all women's health issues."
  }, {
    name: '4 Magic Points for Menstrual Problems',
    indications: 'Irregular periods, painful periods, amenorrhea, heavy bleeding',
    leftPoints: 'SP 6, LR 3',
    rightPoints: 'SP 6, LR 3',
    actions: 'Regulates liver qi and blood. Essential points for all menstrual disorders.'
  }, {
    name: "Dr. Tan's Points for Sperm",
    indications: 'Male infertility, low sperm count, poor sperm motility, impotence',
    leftPoints: 'KI 3, BL 23, GV 4, REN 4',
    rightPoints: 'KI 3, BL 23, GV 4, REN 4',
    actions: 'Tonifies kidney yang and essence. Specific protocol for male reproductive health.'
  }, {
    name: 'Balance Method Pain Protocol',
    indications: 'Any localized pain using balance method principles',
    leftPoints: 'Find ashi points on balancing meridian opposite side',
    rightPoints: 'Alternative balancing meridian points',
    actions: 'Use 5 systems to find balancing meridian. Palpate for ashi points. Never needle local pain area.'
  }, {
    name: 'Menopause and All Gyno Pattern',
    indications: 'Female disorders, including menopause, PMS, emotional instability, fibroids, PCOS and all reproductive and sexual dysfunctions. Normalizes hormones and treats female disorders',
    leftPoints: <>
          Zhongzhu (TH 3), Waiguan (TH 5), Hegu (LI 4), Yangxi (LI 5),
          Sanyinjiao (SP 6), Yinlingquan (SP 9), Dazhong (KI 4), Fuliu (KI 7)
          <br data-id="element-645" />
          <br data-id="element-646" />
          <span className="italic" data-id="element-647">Deficiency - add:</span> Rangu (KI 2),
          Dazhong (KI 4), Fuliu (KI 7)
        </>,
    rightPoints: 'Tongli (HT 5), Neiguan (PC 6), Daling (PC 7), Yanglingquan (GB 34), Zulinqi (GB 41), Zusanli (ST 36), Shangjuxu (ST 37), Fenglong (ST 40)',
    actions: <>
          Standard needling techniques;
          <br data-id="element-648" />
          Alternate sides from treatment to treatment;
          <br data-id="element-649" />
          Needle the <span className="italic" data-id="element-650">ashi</span> point on or around the
          points indicated
        </>
  }, {
    name: 'Heat Pattern',
    indications: 'Infections, inflammation, fever, red/hot/swollen conditions, acute inflammation',
    leftPoints: 'LI 4, LI 11, ST 44, ST 45',
    rightPoints: 'LU 10, LU 11, SP 2, SP 3',
    actions: 'Rapid, forceful pulse. Clears heat, reduces inflammation.'
  }, {
    name: 'Menopause Pattern',
    indications: 'All gynecological issues, menopause, hot flashes, night sweats, hormonal imbalance, mood swings',
    leftPoints: 'TH 1, TH 3, SP 1, SP 6, LR 3',
    rightPoints: 'PC 7, HT 7, ST 36, GB 34, GB 41',
    actions: 'Thin, rapid pulse. Regulates hormones, calms shen, balances yin-yang.'
  }];
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-651">
      <h2 className="text-3xl font-bold text-gray-800 mb-6 pb-3 border-b-4 border-purple-600" data-id="element-652">
        Treatment Protocols with Left/Right Point Systems
      </h2>
      <TableWrapper searchTerm={searchTerm} data-id="element-653">
        <table className="w-full border-collapse bg-white rounded-lg overflow-hidden shadow-lg" data-id="element-654">
          <thead data-id="element-655">
            <tr className="bg-gradient-to-r from-purple-600 to-purple-800 text-white" data-id="element-656">
              <th className="p-4 text-left text-sm font-semibold" data-id="element-657">
                Protocol Name
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-658">
                Indications
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-659">
                LEFT Side Points
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-660">
                RIGHT Side Points
              </th>
              <th className="p-4 text-left text-sm font-semibold" data-id="element-661">
                Actions & Notes
              </th>
            </tr>
          </thead>
          <tbody data-id="element-662">
            {protocols.map((protocol, index) => <tr key={index} className="border-b border-gray-200 hover:bg-blue-50 transition-colors even:bg-gray-50" data-id="element-663">
                <td className="p-3 font-semibold text-gray-800" data-id="element-664">
                  {protocol.name}
                </td>
                <td className="p-3 text-green-700" data-id="element-665">{protocol.indications}</td>
                <td className="p-3 font-mono text-red-600 font-medium" data-id="element-666">
                  {protocol.leftPoints}
                </td>
                <td className="p-3 font-mono text-red-600 font-medium" data-id="element-667">
                  {protocol.rightPoints}
                </td>
                <td className="p-3 text-purple-700 italic" data-id="element-668">
                  {protocol.actions}
                </td>
              </tr>)}
          </tbody>
        </table>
      </TableWrapper>
    </div>;
}